// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"1d8a3178","787":"8308bc4c"}[chunkId] + ".chunk.js";
};